var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$planExist())?_c('div',{staticClass:"box"},[_c('h2',{staticClass:"title is-3"},[_vm._v(_vm._s(_vm.$t('plan.no_current_plan')))]),_c('b-button',{staticClass:"is-primary",on:{"click":function($event){return _vm.$router.push('/generate_training_plan')}}},[_vm._v(" "+_vm._s(_vm.$t('plan.generate_training_plan'))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }